import { useEffect, useRef } from 'react'
import {
  Navigate,
  Outlet,
  useSearchParams,
  ScrollRestoration,
} from 'react-router-dom'
import { routes } from '@/router'
import { queryClient } from '@/api/react-query'
import { useValidateSession } from '@/api/user-manager'
import {
  clearStoragePreservingAnnouncements,
  clearViewAsUserKey,
  setViewAsUserKey,
} from '@/helpers'
import { Loading } from '../loading'

export function PrivateRoute() {
  const [searchParams, setSearchParams] = useSearchParams()

  const searchParamToken = searchParams.get('token')
  const appliedToken = useRef<string | null>(null)

  if (searchParamToken && appliedToken.current !== searchParamToken) {
    appliedToken.current = searchParamToken
    localStorage.setItem('access_token', searchParamToken)
    queryClient.clear()

    const viewAsUserKey = searchParams.get('as')
    if (viewAsUserKey) {
      setViewAsUserKey(viewAsUserKey)
    } else {
      clearViewAsUserKey()
    }
  }

  const { error, isSuccess: isValidToken, isLoading } = useValidateSession()

  useEffect(() => {
    if (isValidToken) {
      searchParams.delete('token')
      searchParams.delete('as')
      setSearchParams(searchParams)
    }
  }, [isValidToken])

  useEffect(() => {
    if (error) {
      clearStoragePreservingAnnouncements()
    }
  }, [error])

  if (isLoading) {
    return <Loading />
  }

  return isValidToken ? (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  ) : (
    <Navigate to={routes.session.signin} />
  )
}
